import { render, staticRenderFns } from "./DeleteArticleInPending.vue?vue&type=template&id=7c9ff03c&scoped=true"
import script from "./DeleteArticleInPending.vue?vue&type=script&lang=js"
export * from "./DeleteArticleInPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9ff03c",
  null
  
)

export default component.exports